module.exports = __webpack_public_path__ + "4b517d3501dba9c5a9b6ab4d1eb3bf84.png";